// Canonical public domain for client-facing links (never the Emergent preview host)
export const publicOrigin = () =>
  (process.env.REACT_APP_PUBLIC_BASE_URL || window.location.origin).replace(/\/$/, "");

export const publicPreviewUrl = (slug) => (slug ? `${publicOrigin()}/pv/${slug}` : null);
